"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "cardbox" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Card = (0, vue_1.resolveComponent)("Card");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.cards, (card, index) => {
            return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                key: card.name,
                class: (0, vue_1.normalizeClass)({ 'cards-stack': (index > 0), 'cards-stack-first': (index === 0) })
            }, [
                (0, vue_1.createVNode)(_component_Card, { card: card }, null, 8, ["card"])
            ], 2));
        }), 128))
    ]));
}
